import { render, staticRenderFns } from "./EventoBasicInfo.vue?vue&type=template&id=5bd384b3"
import script from "./EventoBasicInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoBasicInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports